import type { ActionFlow, ImportMap, LoginData } from '@/types';
import { getImportMap } from '@/utilities/helpers';
import { logger } from '@/utilities/logger';

const log = logger.createLogger('FLOW-RUNNER');

class Action {
  actionName: string;
  importPrefix = '@b2x/loginaction/';
  importMap: ImportMap;
  loginData: LoginData;
  importMapActionUrl: string;

  constructor(actionName: string, loginData: LoginData, importMap: ImportMap) {
    this.actionName = actionName;
    this.importMap = importMap;
    this.loginData = loginData;
    this.importMapActionUrl = this.importMap.imports[`${this.importPrefix}${this.actionName}`];
  }

  async runCondition() {
    const parts = this.importMapActionUrl.split('/');
    parts[parts.length - 1] = 'condition.js';

    const conditionScriptUrl = parts.join('/');

    const shouldRun = await (await import(/* @vite-ignore */ conditionScriptUrl)).default(this.loginData);

    log.info(`Checking condition for action: ${this.actionName}`, shouldRun ? '🚧' : '❌');

    return shouldRun;
  }

  async runAction() {
    const actionFn = await import(/* @vite-ignore */ this.importMapActionUrl);

    await actionFn.default(this.loginData);

    log.info(` ✅ Executed action: ${this.actionName}`);
  }

  async run() {
    log.info(`🚀 Running action: ${this.actionName}`);

    try {
      if (await this.runCondition()) {
        await this.runAction();
      }
    } catch (error) {
      log.warn(`⛔️ Error running condition or action: ${this.actionName}`, error);
    }
  }
}

export async function runMarketFlow(marketFlow: ActionFlow, loginData: LoginData) {
  const importMap = getImportMap();

  for (const action of marketFlow) {
    if ((importMap.imports as any)[`@b2x/loginaction/${action}`]) {
      await new Action(action, loginData, importMap).run();
    }
  }
}
